import http from 'hub-http/clients/apiClient';
const CURRENCY_URI = 'forecasting/v1/currency/to-preferred';
// TODO: Remove this file when cleaning up Forecasting:MultipleOutcomes gate
export const currencyToPreferredRequest = data => http.post(CURRENCY_URI, {
  data
});